export enum STATUS {
    Draft = 0,
    REG = 6,
    Review = 7,
    WrittenReply = 10,
    Rejected = 11,
    Processing = 15,
    Question = 20,
    InProgress = 30,
    MeetingScheduled = 40,
    MeetingHeld = 50,
    Resolved = 80,
    Revoked = 90,
    Closed = 99
}

export enum STATUS_NAMES {
    Draft = "Черновик",
    REG = "Зарегистрирована",
    Review = "На рассмотрении",
    WrittenReply = "Письменный ответ",
    Rejected = "Отклонена",
    Processing = "Обрабатывается",
    Question = "Требуется уточнение",
    InProgress = "Выполняется",
    MeetingScheduled = "Встреча назначена",
    MeetingHeld = "Встреча проведена",
    Resolved = "Выполнена",
    Revoked = "Отозвана",
    Closed = "Закрыта"
}

export enum APPOINTED_STATUS {
    appointed,
    confirmed,
    refused
}
